export default __webpack_public_path__ + "static/media/ic-fruit-avocado.ebe58693.svg";